import { Link, useLocation } from "react-router-dom";
import { RightArrowIcon } from "./RightArrow";

const ParallaxTwoColVideoSec = ({ data }: any) => {
  const { pathname } = useLocation();

  return (
    <>
      {data && (
        <section className="work__area section-py-120">
          <div className={`container ${pathname === "/" ? "px-0" : ""}`}>
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-6 col-md-9">
                <div className="about__images work__images">
                  <img
                    src={data?.image?.node?.sourceUrl ?? ""}
                    width={600}
                    height={545}
                    alt="img-text"
                    className={`main-img ${pathname === "/" ? "home" : ""}`}
                  />
                  <img
                    src="/assets/img/others/about_shape.svg"
                    width={173}
                    height={78}
                    alt="img-text"
                    className="shape alltuchtopdown"
                    style={{ right: 50 }}
                  />
                  <Link
                    to={data?.videoLink ?? ""}
                    target="_blank"
                    className="popup-video"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="28"
                      viewBox="0 0 22 28"
                      fill="none"
                    >
                      <path
                        d="M0.19043 26.3132V1.69421C0.190288 1.40603 0.245303 1.12259 0.350273 0.870694C0.455242 0.6188 0.606687 0.406797 0.79027 0.254768C0.973854 0.10274 1.1835 0.0157243 1.39936 0.00193865C1.61521 -0.011847 1.83014 0.0480663 2.02378 0.176003L20.4856 12.3292C20.6973 12.4694 20.8754 12.6856 20.9999 12.9535C21.1245 13.2214 21.1904 13.5304 21.1904 13.8456C21.1904 14.1608 21.1245 14.4697 20.9999 14.7376C20.8754 15.0055 20.6973 15.2217 20.4856 15.3619L2.02378 27.824C1.83056 27.9517 1.61615 28.0116 1.40076 27.9981C1.18536 27.9847 0.97607 27.8983 0.792638 27.7472C0.609205 27.596 0.457661 27.385 0.352299 27.1342C0.246938 26.8833 0.191236 26.6008 0.19043 26.3132Z"
                        fill="currentcolor"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className={`work__content ${pathname === "/" ? "px-5" : ""}`}
                >
                  <div className="section__title mb-20">
                    <span className="sub-title">
                      {data?.highlightText ?? ""}
                    </span>
                    <h2 className="title" style={{ fontSize: 32 }}>
                      {data?.title}
                    </h2>
                  </div>
                  <p>{data?.content}</p>
                  <div className="work__list-wrap">
                    {data?.workListRepeater?.map((item: any, index: number) => (
                      <div className="work__list-box" key={index}>
                        <div className="work__list-box-top">
                          <div className="icon">
                            <i className="flaticon-profit"></i>
                          </div>
                          <h4 className="title" style={{ fontSize: 16 }}>
                            {item?.title}
                          </h4>
                        </div>
                      </div>
                    ))}
                  </div>
                  {data?.link && (
                    <div className="tg-button-wrap">
                      <Link
                        to={data?.link}
                        // target="_blank"
                        className="btn arrow-btn"
                      >
                        Register Now
                        {/* <img
                          src="/assets/img/icons/right_arrow.svg"
                          alt="img-text"
                          className="injectable"
                          width={16}
                          height={14}
                        /> */}
                        <RightArrowIcon />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ParallaxTwoColVideoSec;
